import { Component } from "react"
import PropTypes from "prop-types"
import { css } from "@emotion/core"
import Icon from "components/planning_center_icon"
import { colors } from "components/shared/admin_colors"
import { Menu, MenuButton, MenuList, MenuLink } from "@reach/menu-button"

const styles = {
  prependedLabel: css`
    color: var(--t-fill-color-neutral-030);
    font-size: 14px;
    left: 10px;
    position: absolute;
    top: 9px;
    z-index: 1;
  `
}

class Search extends Component {
  constructor(props) {
    super(props)

    const campuses = [{ id: null, name: "All Campuses" }].concat(props.campuses)
    const categories = [{ id: null, name: "All Categories" }].concat(props.categories, {
      id: null,
      name: "Archived"
    })

    const initialCampus = campuses.find(
      campus => props.campusId !== null && campus.id === parseInt(props.campusId)
    )

    const initialCategory = props.archived
      ? categories[categories.length - 1]
      : categories.find(
          category => props.categoryId !== null && category.id === parseInt(props.categoryId)
        )

    this.state = {
      archived: props.archived,
      q: "",
      campus: initialCampus || campuses[0],
      category: initialCategory || categories[0],
      campuses,
      categories,
      copied: false
    }

    this.submitSearch = this.submitSearch.bind(this)
    this.handleCampusChange = this.handleCampusChange.bind(this)
    this.handleCategoryChange = this.handleCategoryChange.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.campus !== this.state.campus || prevState.category !== this.state.category) {
      this.updateHistory()
    }
  }

  render() {
    const { category, categories, campus, campuses } = this.state

    return (
      <div className="d-f@md w-100% jc-sb">
        <CampusAndCategoryFilters
          campuses={campuses}
          categories={categories}
          styles={styles}
          campus={campus}
          category={category}
          onCampusChange={this.handleCampusChange}
          onCategoryChange={this.handleCategoryChange}
        />
        <div className="p-r">
          <div
            className="p-4p prepended-label x-line"
            css={{
              minWidth: 320,
              "@media (max-width: 719px)": {
                borderLeft: 0,
                borderTop: "1px solid var(--pane--border-color)"
              }
            }}
          >
            <span className="label" css={styles.prependedLabel}>
              <Icon symbol="general#search" />
            </span>
            <input
              type="text"
              id="search"
              className="big-input"
              name="search"
              placeholder="Search"
              aria-label="Search signups"
              onChange={e => this.setState({ q: e.target.value }, this.submitSearch)}
              css={{
                "--text-input--border-width": 0,
                "--text-input--box-shadow": "none",
                paddingLeft: "2rem !important"
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  submitSearch() {
    const { onSearch } = this.props
    const { archived, campus, category, q } = this.state

    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      onSearch({ archived, categoryId: category.id, campusId: campus.id, q })
    }, 250)
  }

  handleCategoryChange(category) {
    const archived = category.name === "Archived" ? true : false
    this.setState({ archived, category }, this.submitSearch)
  }

  handleCampusChange(campus) {
    this.setState({ campus }, this.submitSearch)
  }

  updateHistory() {
    const campusString = this.state.campus.id ? `campuses=${this.state.campus.id}` : null
    const categoryString = this.state.category.id ? `categories=${this.state.category.id}` : null
    const archived = this.state.archived ? `archived=${this.state.archived}` : null
    const params = [archived, campusString, categoryString].filter(str => str !== null)
    const paramString = params.length > 0 ? `?${params.join("&")}` : ""
    const path = `/signups${paramString}`
    history.replaceState(history.state, "", path)
  }
}

const { bool, string, func } = PropTypes

Search.propTypes = {
  isOrgAdmin: bool.isRequired,
  ccaEnabled: bool,
  ccwEnabled: bool,
  ccaRegistrationsPublished: bool,
  ccwRegistrationsPublished: bool,
  churchCenterDisabledOrUnpublished: bool,
  onNewClick: func
}

const CampusAndCategoryFilters = ({
  categories = [],
  campuses = [],
  styles = {},
  campus,
  category,
  onCampusChange = () => {},
  onCategoryChange = () => {}
}) => {
  return (
    <div className="d-f p-1" css={{ gap: "0.5rem" }}>
      {campuses.length > 2 && ( // main campus, "All Campuses", plus more
        <Menu>
          <MenuButton className="select--small select ws-nw">{campus.name}</MenuButton>
          <MenuList>
            {campuses.map(c => (
              <MenuLink
                className="dropdown-menu-item w-100%"
                key={c.id}
                onClick={() => onCampusChange(c)}
              >
                {c.name}
              </MenuLink>
            ))}
          </MenuList>
        </Menu>
      )}
      <Menu>
        <MenuButton className="select--small select ws-nw">{category.name}</MenuButton>
        <MenuList>
          {categories.map(c => (
            <MenuLink
              className="dropdown-menu-item w-100%"
              key={c.name}
              onClick={() => onCategoryChange(c)}
            >
              {c.name}
            </MenuLink>
          ))}
        </MenuList>
      </Menu>
    </div>
  )
}

export default Search
